// extracted by mini-css-extract-plugin
module.exports = {"banner":"SiteBanner_banner__O76Mp","bannerAnimateIn":"SiteBanner_bannerAnimateIn__MwKYA","content":"SiteBanner_content__qqTkV","wysiwyg":"SiteBanner_wysiwyg__HgSoT"};